module.exports = __webpack_public_path__ + "img/carro.b471cb2e.png";